import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { format, subDays, startOfMonth, endOfMonth } from 'date-fns';

const ReportTemplateCard = ({ template, onGenerate, generating, icon, iconColor }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [startDate, setStartDate] = useState(format(subDays(new Date(), 30), 'yyyy-MM-dd'));
  const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'));

  const handleQuickRange = (range) => {
    const today = new Date();
    switch (range) {
      case 'today':
        setStartDate(format(today, 'yyyy-MM-dd'));
        setEndDate(format(today, 'yyyy-MM-dd'));
        break;
      case 'week':
        setStartDate(format(subDays(today, 7), 'yyyy-MM-dd'));
        setEndDate(format(today, 'yyyy-MM-dd'));
        break;
      case 'month':
        setStartDate(format(startOfMonth(today), 'yyyy-MM-dd'));
        setEndDate(format(endOfMonth(today), 'yyyy-MM-dd'));
        break;
      case '30days':
        setStartDate(format(subDays(today, 30), 'yyyy-MM-dd'));
        setEndDate(format(today, 'yyyy-MM-dd'));
        break;
    }
  };

  const handleGenerate = () => {
    onGenerate(template, { start: startDate, end: endDate });
    setShowDatePicker(false);
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-md border border-border hover:shadow-lg transition-all">
      <div className="flex items-start gap-4 mb-4">
        <div className="w-12 h-12 rounded-lg bg-muted flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-1">{template?.name}</h3>
          <p className="text-xs text-muted-foreground">{template?.description}</p>
        </div>
      </div>
      <div className="mb-4">
        <span className="inline-block px-3 py-1 rounded-full bg-muted text-xs font-medium text-foreground capitalize">
          {template?.report_type}
        </span>
      </div>
      {showDatePicker ? (
        <div className="space-y-3">
          <div className="flex gap-2">
            {['today', 'week', 'month', '30days']?.map(range => (
              <button
                key={range}
                onClick={() => handleQuickRange(range)}
                className="px-2 py-1 rounded text-xs bg-muted hover:bg-muted/80 text-foreground"
              >
                {range === 'today' ? 'Today' : range === 'week' ? '7 Days' : range === 'month' ? 'This Month' : '30 Days'}
              </button>
            ))}
          </div>
          <Input
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e?.target?.value)}
          />
          <Input
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e?.target?.value)}
          />
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              fullWidth
              onClick={() => setShowDatePicker(false)}
            >
              Cancel
            </Button>
            <Button
              size="sm"
              fullWidth
              onClick={handleGenerate}
              disabled={generating}
              iconName="Download"
              iconPosition="right"
            >
              {generating ? 'Generating...' : 'Generate'}
            </Button>
          </div>
        </div>
      ) : (
        <Button
          fullWidth
          onClick={() => setShowDatePicker(true)}
          disabled={generating}
          iconName="FileText"
          iconPosition="left"
        >
          Generate Report
        </Button>
      )}
    </div>
  );
};

export default ReportTemplateCard;